import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import useProductSchema from '../../../../hooks/schema/useProductSchema';
import { modelOf } from '../../../../prop-types';
import { LocationContextPropType } from '../../../../services/LocationContext';
import RouteService from '../../../../services/RouteService';
import AccountStore from '../../../../store/AccountStore';
import ConfigStore from '../../../../store/ConfigStore';
import CountryStore from '../../../../store/CountryStore';
import CurrencyStore from '../../../../store/CurrencyStore';
import SEOSchema from '../../../head/SEOSchema';
import FullProduct from '../../../../models/product/FullProduct';
import SchemaType from "../../../../types/seo/SchemaType";

const ProductGroupSchema = ({
  accountStore,
  configStore,
  countryStore,
  currencyStore,
  routeService,
  locationContext,
  intl,
  product,
}) => {
  const [getProductSchema, getProductGroupSchema] = useProductSchema({
    accountStore,
    configStore,
    countryStore,
    currencyStore,
    routeService,
    locationContext,
    intl,
  });
  const productGroupSchema = getProductGroupSchema(product);

  return <SEOSchema data={productGroupSchema} />;
};

ProductGroupSchema.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  countryStore: modelOf(CountryStore).isRequired,
  currencyStore: modelOf(CurrencyStore).isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  locationContext: LocationContextPropType.isRequired,
  intl: intlShape.isRequired,
  product: modelOf(FullProduct).isRequired,
};

export default injectIntl(
  inject(
    'accountStore',
    'configStore',
    'countryStore',
    'currencyStore',
    'routeService',
    'locationContext'
  )(observer(ProductGroupSchema))
);
